var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-100 w-100"},[(_vm.userIsAdmin && !_vm.userIsSelected)?_c('home-admin-container',{attrs:{"pudk":_vm.pudk}}):_c('home-client-container')],1)}
var staticRenderFns = []

export { render, staticRenderFns }